module.exports = __webpack_public_path__ + "img/flavicon.b44def56.png";